// ProcessSheet.js
import React, { useState } from 'react';
import vtech from '../../media/vtech_logo.png'
import axis from '../../media/axis_logo.png'
import { HelmetAsync } from '../../utils/HelmetAsync';
// import { bondOptions } from '../../data/bondOptions';

const ProcessSheet = () => {
    const [formData, setFormData] = useState({
        cname: '',
        batch: '',
        grade: '',
        // btv: '',
        width1: '',
        length1: '',
        dialayer: '',
        slts: '',
        nmould: '',
        nsm: '',
        size: '',
        nss: ''
    });

    const [processData, setProcessData] = useState(null);
    const [bondData, setBondData] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
        ...prev,
        [name]: value
        }));
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setProcessData({...formData});
    // };

    const handlePrint = () => {
        window.print();
    };

    const bondOptions = [
        { value: "2000/7.5/7.479/11.218/650", label: "2000" },
        { value: "2003/7.4/7.479/11.218/650/15", label: "2003" },

        { value: "70/9.0/7.479/11.218/600", label: "70" },
        { value: "74/7.5/7.479/11.218/600", label: "74" },
        { value: "75/7.2/6.41/9.615/600/5", label: "75" },
        { value: "76/7.0/6.41/9.615/600/10", label: "76" },
        { value: "76.5/7.0/6.41/9.615/600/12.5", label: "76.5" },
        
        { value: "80/7.5/7.479/11.218/635", label: "80" },
        { value: "80.5/7.5/7.479/11.218/635/2.5", label: "80.5" },
        { value: "81/7.45/7.479/11.218/635/5", label: "81" },
        { value: "81.5/7.425/7.479/11.218/635/7.5", label: "81.5" },
        { value: "82/7.4/7.479/11.218/635/10", label: "82" },
        { value: "83/7.3/7.479/11.218/635/15", label: "83" },
        { value: "83.5/7.25/7.479/11.218/635/17.5", label: "83.5" },
        { value: "84/7.2/7.479/11.218/635/20", label: "84" },
        { value: "85/7.1/7.479/11.218/635/25", label: "85" },
        
        { value: "110/8.35/5.342/8.013/780", label: "110" },
        { value: "111/8.00/5.342/8.013/780/5", label: "111" },
        { value: "112/7.80/5.342/8.013/780/10", label: "112" },
        { value: "113/7.45/5.342/8.013/780/15", label: "113" },
        { value: "114/7.10/5.342/8.013/780/20", label: "114" },
        
        { value: "210/9.05/7.479/11.218/650", label: "210" },
        { value: "212/8.20/7.479/11.218/650/10", label: "212" },
        { value: "213/7.80/7.479/11.218/650/15", label: "213" },
        { value: "214/7.4/7.479/11.218/650/20", label: "214" },
        { value: "320/12.40/3.73/6.41/810", label: "320" },
        
        { value: "800/8.70/6.41/9.615/650", label: "800" },
        { value: "800.5/8.50/6.41/9.615/650/2.5", label: "800.5" },
        { value: "801/8.30/6.41/9.615/650/5", label: "801" },
        { value: "802/8.15/5.35/8.013/650/10", label: "802" },
        { value: "803/7.40/5.35/8.013/650/15", label: "803" },
        { value: "810/8.50/6.41/9.615/650", label: "810" },
        { value: "812/7.20/5.35/8.013/650/10", label: "812" },
        { value: "814/5.70/4.27/6.41/650/20", label: "814" },
        { value: "814.5/6.00/4.27/6.41/650/22.5", label: "814.5" },
        { value: "815/6.20/4.27/6.41/650/25", label: "815" }
    ];

    const getBondDataFromGrade = (grade) => {
        if (!grade) return null;
        
        const gradeValues = grade.split('-');
        if (gradeValues.length < 3) return null;
        
        const bondValue = gradeValues[2]; // Get the bond value from grade (third part)
        
        // Find the bond option that matches the bond value
        const bondOption = bondOptions.find(option => option.label === bondValue);
        
        if (bondOption) {
        return {
            value: bondOption.value,
            label: bondOption.label
        };
        }
        
        return null;
    };

    // Function to extract length from size (e.g., "3x3x110" → 110)
    const getStoneLengthFromSize = (size) => {
        if (!size) return 0;
        
        const dimensions = size.split('x');
        if (dimensions.length < 3) return 0;
        
        // Return the last dimension (length)
        return parseFloat(dimensions[dimensions.length - 1]) || 0;
    };

    // Function to calculate total stones based on the new logic
    const calculateTotalStones = (data) => {
        if (!data) return 0;
        
        const nmould = parseInt(data.nmould) || 0;
        const nsm = parseInt(data.nsm) || 0;
        const nss = parseInt(data.nss) || 0;
        const mouldLength = parseInt(data.length1) || 0;
        
        // Extract stone length from size input
        const stoneLength = getStoneLengthFromSize(data.size);
        
        if (stoneLength === 0 || mouldLength === 0) {
        return nmould * nsm * nss;
        }
        
        // Calculate how many stones fit in the mould length
        const stonesPerLength = Math.floor(mouldLength / stoneLength);
        
        // Total stones = moulds × sticks/mould × stones/stick × stones/length
        return nmould * nsm * nss * stonesPerLength;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Extract bond data from grade input
        const bondDataFromGrade = getBondDataFromGrade(formData.grade);
        
        if (!bondDataFromGrade) {
        alert('Please enter a valid Grade format (e.g., B151-49-81-60) where the third value is a valid bond type');
        return;
        }
        
        setBondData(bondDataFromGrade);
        setProcessData({...formData});
    };

    const handleReset = () => {
        setFormData({
        cname: '',
        batch: '',
        grade: '',
        // btv: '',
        width1: '',
        length1: '',
        dialayer: '',
        slts: '',
        nmould: '',
        nsm: '',
        size: '',
        nss: ''
        });
        setProcessData(null);
        setBondData(null);
    };

    // Calculate values based on the PHP logic
    const gradeValues = processData?.grade ? processData.grade.split('-') : [];
    // const bondValues = processData?.btv ? processData.btv.split('/') : [];
    const bondValues = bondData?.value ? bondData.value.split('/') : [];
    const conc = gradeValues[3] || 0;
    const bondTypeFromGrade = gradeValues[2] || '';
    // const stone = processData ? processData.nmould * processData.nsm * processData.nss : 0;
    const stone = processData ? calculateTotalStones(processData) : 0;
    const effwidth = processData ? processData.width1 - processData.slts : 0;
    const vol = processData ? (effwidth * processData.length1 * processData.dialayer) / 1000 : 0;
    const gst = vol * 0.0088 * conc;
    const bst = vol * (bondValues[1] || 0);
    const gpm = (gst * (processData?.nsm || 0)) * (processData?.nmould || 0);
    const bpm = (bst * (processData?.nsm || 0)) * (processData?.nmould || 0);
    const kryo = bondValues[5] ? bpm * (bondValues[5] / 100) : 0;
    const p1 = processData ? (((((processData.width1 - processData.slts) * processData.length1 * processData.nsm) / 100) * (bondValues[2] || 0))) / 2 : 0;
    const p2 = processData ? (((((processData.width1 - processData.slts) * processData.length1 * processData.nsm) / 100) * (bondValues[3] || 0))) / 2 : 0;

    // Get stone length for display
    const stoneLength = processData ? getStoneLengthFromSize(processData.size) : 0;
    const stonesPerLength = stoneLength && processData?.length1 ? Math.floor(processData.length1 / stoneLength) : 1;

    const currentDate = new Date().toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });

    const userRole = localStorage.getItem('userRole');
    const title = `Process Sheet - BreyERP`;

    const [selectedView, setSelectedView] = useState('view1');

    const contentMap = {
        view1: {
            image: axis,
            text: 'Axis Diamond Tools',
            alt: 'Axis Diamond Tools'
        },
        view2: {
            image: vtech,
            text: 'V-TECH INDUSTRIES',
            alt: 'V-TECH INDUSTRIES'
        }
    };

    const currentContent = contentMap[selectedView];

return (
<>
    <HelmetAsync title={title} />
    <div className="flex items-center justify-between mb-3">
        <h1 className="text-xl font-bold">Process Sheet</h1>
        {/* <h1 className="text-xl font-bold">Input</h1> */}

        {/* <Button
            // onClick={() => setIsModalOpen(true)}
            onClick={() => {
                setMode('create');
            setIsModalOpen(true);
            }}
        >
            <MdIcons.MdAdd className='inline mb-1'/> New RGP
        </Button> */}
    </div>

    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">

        {/* Main content with process sheet */}
        {/* <div className="flex-1 ml-0 md:ml-1/3 lg:ml-1/4 p-4"> */}
        <div className="flex-1 lg:pr-4 overflow-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">

            {/* {processData ? ( */}
            {processData && bondData ? (
                <>
                <div className="flex justify-between items-center">
                    {/* Switch Buttons */}
                    <div className="button-group">
                        <button 
                        onClick={() => setSelectedView('view1')}
                        className={selectedView === 'view1' ? 'active bg-blue-800 hover:bg-gray-900 text-white px-2 rounded' : 'px-2'}
                        >
                        Axis
                        </button>
                        <button 
                        onClick={() => setSelectedView('view2')}
                        className={selectedView === 'view2' ? 'active bg-blue-800 hover:bg-gray-900 text-white px-2 rounded' : 'px-2'}
                        >
                        V-Tech
                        </button>
                    </div>
                    <p className="mb-0">Total Volume: {vol} cm<sup>3</sup></p>
                    <button 
                    onClick={handlePrint}
                    className="bg-gray-800 hover:bg-gray-900 text-white p-2 rounded"
                    >
                    Print Sheet
                    </button>
                </div>

                <table className="mt-4 w-full border-collapse border border-gray-400 eprint">
                    <tbody>
                    <tr>
                        <td rowSpan="2" colSpan="3" className="border border-gray-400 text-center p-2">
                        {/* <img src={vtech} alt="V-Tech" className="h-16 mx-auto" /> */}
                        <img src={currentContent.image} alt={currentContent.alt} className="h-16 mx-auto" />
                        </td>
                        <td rowSpan="2" colSpan="3" className="border border-gray-400 text-center p-2">
                            <strong className='uppercase'>{currentContent.text}</strong><br />
                            Plot no. 70, Sector 5, IMT Manesar<br />Gurugram, Haryana 122050
                        </td>
                        <td colSpan="3" className="border border-gray-400 p-2">S. No.</td>
                    </tr>
                    <tr>
                        <td colSpan="3" className="border border-gray-400 p-2">Process No.</td>
                    </tr>
                    <tr>
                        <td colSpan="9" className="border border-gray-400 text-center p-2">
                        <h2 className="text-2xl font-bold">Process Sheet</h2>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="9" className="border border-gray-400 p-2">
                        <div className="text-right">Date: {currentDate}</div>
                        <table className="w-11/12 mx-auto border-none">
                            <tbody>
                            <tr>
                                <td className="w-1/2 p-1">Customer: <strong>{processData.cname}</strong></td>
                                <td className="p-1">Batch No.: <strong>{processData.batch}</strong></td>
                            </tr>
                            <tr>
                                <td className="p-1">Grade: <strong>{processData.grade}</strong></td>
                                <td className="p-1">Standard Mould Size: <strong>{processData.width1} * {processData.length1}</strong></td>
                            </tr>
                            <tr>
                                <td className="p-1">Size: <strong>{processData.size}</strong></td>
                                <td className="p-1">No. of stones/mould: <strong>{processData.nsm} * {processData.nss} = {processData.nsm * processData.nss}</strong></td>
                            </tr>
                            <tr>
                                <td className="p-1">Total no. of stones: <strong>{stone}</strong></td>
                                <td className="p-1">No. of moulds to be processed: <strong>{processData.nmould}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan="3" className="border border-gray-400 text-center p-2">RAW MATERIAL PLANNING</th>
                        <th colSpan="2" className="border border-gray-400 text-center p-2">ABRASIVE [gm]</th>
                        <th colSpan="2" className="border border-gray-400 text-center p-2">BOND [gm]</th>
                        <th colSpan="2" className="border border-gray-400 text-center p-2">TOTAL [gm]</th>
                    </tr>
                    <tr>
                        <td colSpan="3" className="border border-gray-400 text-center p-2">Weight for each cup</td>
                        <td colSpan="2" className="border border-gray-400 text-center p-2"><strong>{gst.toFixed(3)}</strong></td>
                        <td colSpan="2" className="border border-gray-400 text-center p-2"><strong>{bst.toFixed(3)}</strong></td>
                        <td colSpan="2" className="border border-gray-400 text-center p-2"><strong>{(gst + bst).toFixed(3)}</strong></td>
                    </tr>
                    <tr>
                        <td rowSpan="2" colSpan="3" className="border border-gray-400 text-center p-2">
                        Total weight for <strong>{processData.nmould}</strong> moulds.
                        </td>
                        <td rowSpan="2" colSpan="2" className="border border-gray-400 text-center p-2">
                        <strong>{gpm.toFixed(3)}</strong>
                        </td>
                        <td rowSpan="2" colSpan="2" className="border border-gray-400 text-center p-2">
                        <strong>{bpm.toFixed(3)}</strong>
                        </td>
                        <td colSpan="2" className="border border-gray-400 text-center p-2">
                        <strong>{kryo.toFixed(3)}</strong> gm <strong>Kryolite</strong>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="border border-gray-400 text-center p-2">
                        <strong>{(bpm - kryo).toFixed(3)}</strong> gm <strong>Bond</strong> {bondTypeFromGrade}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="9" className="border border-gray-400 p-2">
                        <table className="w-11/12 mx-auto border-none">
                            <tbody>
                            <tr>
                                <td rowSpan="3" className="w-1/3 align-top p-1">MOULD PREPARATION</td>
                                <td className="w-1/3 p-2">1. ____________________________</td>
                                <td className="p-2">4. ____________________________</td>
                            </tr>
                            <tr>
                                <td className="p-2">2. ____________________________</td>
                                <td className="p-2">5. ____________________________</td>
                            </tr>
                            <tr>
                                <td className="p-2">3. ____________________________</td>
                                <td className="p-2">6. ____________________________</td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="pt-2">
                                COPPER PLATED STEEL BAR (SIZE): ____________________________ = <strong>{processData.nmould * processData.nsm * processData.nss}</strong>
                                </td>
                                <td className="pt-2">TEMPERATURE: <strong>{bondValues[4] || 0} °C</strong></td>
                            </tr>
                            </tbody>
                        </table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3" className="border border-gray-400 p-2">PROGRAMME NO.</td>
                        <td colSpan="3" className="border border-gray-400 p-2">
                        PRE-PRESSURE [P1] = <strong>{p1.toFixed(3)} bar</strong>
                        </td>
                        <td colSpan="3" className="border border-gray-400 p-2">
                        MAIN-PRESSURE [P2] = <strong>{p2.toFixed(3)} bar</strong>
                        </td>
                    </tr>
                    {/* Operation rows */}
                    {[
                        "Sintering", "First Inspection", "Filing", "Sandblasting", "Straightening", 
                        "Grinding Width", "Straightening", "Milling Height", "Buffing", "Chamfering",
                        "Cutting Length", "Buffing", "Straightening", "Etching", "First Inspection"
                    ].map((operation, index) => (
                        <tr key={index}>
                        <td className="pl-4 border border-gray-400 p-2" colSpan="2">{operation}</td>
                        <td className="border border-gray-400 p-2"></td>
                        <td className="border border-gray-400 p-2"></td>
                        <td className="border border-gray-400 p-2"></td>
                        <td colSpan="2" className="border border-gray-400 p-2"></td>
                        <td className="border border-gray-400 p-2"></td>
                        <td className="border border-gray-400 p-2"></td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="9" className="border border-gray-400 p-2">
                        <table className="w-full border-none">
                            <tbody>
                            <tr>
                                <td className="pl-4 w-1/2 h-16 align-top">ISSUED BY:</td>
                                <td className="pl-4 h-16 align-top">APPROVED BY:</td>
                            </tr>
                            </tbody>
                        </table>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </>
            ) : (
                <div className="text-center py-12 text-gray-500">
                    <p>Enter the required information in the sidebar and click "Generate Sheet" to create your process sheet.</p>
                    <p className="text-sm mt-2">Format for Grade: B151-49-81-60 (where 81 is the bond type; 60 is the concentration)</p>
                    <p className="text-sm mt-1">Format for Size: 3x3x110 (where 110 is the stone length)</p>
                </div>
            )}
            </div>
        </div>

        {/* Sidebar with input fields */}
        {/* <div className="w-full md:w-1/3 lg:w-1/4 fixed h-screen overflow-y-auto bg-white p-4 shadow-lg z-10"> */}
        <div className="w-full md:w-1/3 lg:w-1/3 bg-white p-4 sticky h-fit shadow-md">
            <h2 className="text-xl font-bold mb-4">Inputs</h2>
            
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-4 gap-4">
                <div className="col-span-3">
                        <label htmlFor="cname" className="block text-sm font-medium text-gray-700">Customer name</label>
                        <input
                        type="text"
                        id="cname"
                        name="cname"
                        value={formData.cname}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>
                    
                    <div>
                        <label htmlFor="batch" className="block text-sm font-medium text-gray-700">Batch No.</label>
                        <input
                        type="text"
                        id="batch"
                        name="batch"
                        value={formData.batch}
                        onChange={handleChange}
                        maxLength="8"
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm tracking-widest focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>
                </div>
                
                <div className="grid grid-cols-5 gap-4">
                    <div className='col-span-3'>
                        <label htmlFor="grade" className="block text-sm font-medium text-gray-700">Grade</label>
                        <input
                        type="text"
                        id="grade"
                        name="grade"
                        value={formData.grade}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                        {bondData && (
                            <p className="text-xs text-green-600 mt-1">
                                Bond = {bondData.label} ; Conc = {conc}
                            </p>
                        )}
                    </div>

                    <div className='col-span-2'>
                        <label className="block text-sm font-medium text-gray-700">Mould System <span className="ml-2 text-xs text-gray-500">[mm]</span></label>
                        <div className="flex items-center space-x-2 mt-1">
                        <input
                            type="number"
                            name="width1"
                            value={formData.width1}
                            onChange={handleChange}
                            className="block w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        <span className="font-bold">x</span>
                        <input
                            type="number"
                            name="length1"
                            value={formData.length1}
                            onChange={handleChange}
                            className="block w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        {/* <span className="text-sm">mm</span> */}
                        </div>
                    </div>

                    
                </div>
                
                {/* <div>
                    <label htmlFor="btv" className="block text-sm font-medium text-gray-700">Bond Type</label>
                    <select
                    id="btv"
                    name="btv"
                    value={formData.btv}
                    onChange={handleChange}
                    className="mt-1 block w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    required
                    >
                    <option value="">Select type...</option>
                    {bondOptions.map(option => (
                        <option key={option.value} value={option.value}>
                        {option.label}
                        </option>
                    ))}
                    </select>
                </div> */}
                

                <div className="grid grid-cols-3 gap-4">
                    <div className='col-span-1'>
                        <label htmlFor="size" className="block text-sm font-medium text-gray-700">Size</label>
                        <input
                        type="text"
                        id="size"
                        name="size"
                        value={formData.size}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>

                    <div>
                        <label htmlFor="dialayer" className="block text-sm font-medium text-gray-700">Abrasive layer <span className="ml-2 text-xs text-gray-500">[mm]</span></label>
                        <div className="flex items-center mt-1">
                        <input
                            type="number"
                            id="dialayer"
                            name="dialayer"
                            value={formData.dialayer}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        {/* <span className="ml-2 text-sm text-gray-500">mm</span> */}
                        </div>
                    </div>
                    <div>
                        <label htmlFor="slts" className="block text-sm font-medium text-gray-700">Slot <span className="ml-2 text-xs text-gray-500">[mm]</span></label>
                        <div className="flex items-center mt-1">
                        <input
                            type="number"
                            id="slts"
                            name="slts"
                            value={formData.slts}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <div>
                        <label htmlFor="nmould" className="block text-sm font-medium text-gray-700">No. of moulds</label>
                        <input
                        type="number"
                        id="nmould"
                        name="nmould"
                        value={formData.nmould}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>
                    <div>
                        <label htmlFor="nsm" className="block text-sm font-medium text-gray-700">Sticks/mould</label>
                        <input
                        type="number"
                        id="nsm"
                        name="nsm"
                        value={formData.nsm}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>
                    <div>
                        <label htmlFor="nss" className="block text-sm font-medium text-gray-700">Stones/stick</label>
                        <input
                        type="number"
                        id="nss"
                        name="nss"
                        value={formData.nss}
                        onChange={handleChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        required
                        />
                    </div>
                </div>
                
                <div className="flex space-x-2 pt-4">
                    <button
                    type="submit"
                    className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md shadow-sm"
                    >
                    Generate Sheet
                    </button>
                    <button
                    type="button"
                    onClick={handleReset}
                    className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-md shadow-sm border border-gray-300"
                    >
                    Reset
                    </button>
                </div>
            </form>
        </div>

    </div>
    </>
  );
};

export default ProcessSheet;